import React from "react";

/*
 * Hebrew lockup thumbnail fallback — navy background + Sky Blue Hebrew text.
 * Pure HTML/CSS, no image assets (handoff README §Assets). Dates without banner
 * art get this instead of a blank (nothing renders blank).
 */

export default function HebrewLockup({ hebrew, label, hebrewSize = 28, className = "" }) {
  return (
    <div
      className={`w-full h-full bg-ic-navy flex flex-col items-center justify-center gap-1 overflow-hidden ${className}`}
    >
      {/* Long words clip to the tile (handoff §5) — never overflow it. */}
      {hebrew && (
        <span
          dir="rtl"
          className="text-ic-sky font-bold max-w-full overflow-hidden text-ellipsis whitespace-nowrap px-1"
          style={{ fontSize: hebrewSize, lineHeight: 1.2 }}
        >
          {hebrew}
        </span>
      )}
      {label && (
        <span
          className={`font-bold tracking-[0.5px] uppercase max-w-full overflow-hidden text-ellipsis whitespace-nowrap px-1 ${
            hebrew ? "text-[10px] leading-[14px] text-ic-lightGray" : "text-[12px] leading-4 text-ic-sky"
          }`}
        >
          {label}
        </span>
      )}
    </div>
  );
}
